import axios from 'axios';
import { getToken, removeToken } from './TokenStorage';

axios.interceptors.request.use(
    config => {
        const token = getToken();
        if (token)
            config.headers.Authorization = token;
        return config;
    },
    error => Promise.reject(error)
);

/**
 * Interceptor de response: em 401/403 limpa o token e redireciona pro login.
 * Bug histórico (mantido aqui pra não repetir): a versão antiga não dava
 * `return` no Promise.reject e não tratava o caso de `error.response` ser
 * undefined (ex: network error), o que disparava "Cannot read properties
 * of undefined (reading 'data')" nos catch de cada caller.
 */
axios.interceptors.response.use(
    response => response,
    error => {
        const status = error && error.response && error.response.status;
        if (status === 401 || status === 403) {
            // Evita loop se já estamos na tela de login
            if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
                removeToken();
                const code = error.response.data && error.response.data.code;
                // eslint-disable-next-line no-console
                console.warn(`Sessão encerrada (HTTP ${status}${code ? ' ' + code : ''}). Redirecionando pro login.`);
                window.location = code === 'SESSION_REVOKED' ? '/?revoked=1' : '/?expired=1';
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
